import {css} from 'styled-components';

import fonts from './base';

export const fontWeightBold = css`
  font-weight: ${fonts.weight.bold};
`;

export const fontWeightSemiBold = css`
  font-weight: ${fonts.weight.semiBold};
`;

export const fontWeightMedium = css`
  font-weight: ${fonts.weight.medium};
`;

export const fontWeightRegular = css`
  font-weight: ${fonts.weight.regular};
`;

export const fontWeightLight = css`
  font-weight: ${fonts.weight.light};
`;
